import { useQuery } from "react-query";
import { checkNewVideo } from "../../../services/api";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateReviewState } from "../../../redux/reviewSlice";
import { updateState } from "../../../redux/commonSlice";

export default ()=> {
    const [enableCheckNewVideo, setEnableCheckNewVideo] = useState(false)
    const dispatch = useDispatch();
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
    const {
        data: checkNewVideoData,
        error: checkNewVideoError,
        isLoading: checkNewVideoLoading,
        refetch: recheckNewVideo,
      } = useQuery(
        [`check_new${commonReducer.event_details?.final_video_id}${commonReducer.event_details?.revision?.revision_video_id}`],
        () => checkNewVideo({event_id: commonReducer.production_event_id, final_video_id: commonReducer.event_details?.final_video_id}),
        { enabled: enableCheckNewVideo , retry: false }
      );

      useEffect(() => {
        if (checkNewVideoData) {
        const responseObject = checkNewVideoData?.data;
        const responseData = responseObject?.data
       if(responseData?.final_video_changed == true) {
        dispatch(updateState({new_video: true}))
        
      
     // dispatch(updateState({new_video: true, under_revision:false, selected_event: {...commonReducer.selected_event, status_type: "Review", status_type_order: 4}}))
       } else {
        dispatch(updateState({new_video: false}))
       }
        setEnableCheckNewVideo(false);
        }
      }, [checkNewVideoData]);


      useEffect(() => {
        if (checkNewVideoError) {
          
          setEnableCheckNewVideo(false);
        }
      }, [checkNewVideoError]);

      const checkVideoArrival = ()=> {
       
            setEnableCheckNewVideo(true)
       
      }

      return [checkVideoArrival, recheckNewVideo]


}